module.exports = __webpack_public_path__ + "static/media/Medusa.409441e3.jpg";